import {WebCam} from "vue-web-cam";
import CryptoJS from 'crypto-js';
import apiUrl from '../../../constants';
import axios from 'axios';
 export default {
	components: {
		WebCam
	},
	  data() {
       return {
		   autoplay: false,
		   selectFirstDevice: true,
		   deviceId: null,
           playsinline: false,
		   resolutionlist: [{
			   name: "640×480",
			   resolution: {
				   height: 480,
				   width: 640},
		   },
		   {
			   name:"960×720",
			   resolution:{height:720,width:960},
		   },
		   {
			   name:"1280×960",
			   resolution:{height:960,width:1280},
		   }

		   ],
		   input: {},
		   warehouseid: '',
		   createdbyEmail: '',
		   user_type: '',
		   listClientData: '',
		   client: '',
		   srrto: '',
		   cameras: [],
		   cameralist: '',
		  
           imagetype: '',
           imagetypearray: [{id:1,imagetype:"Label"},
                            {id:2,imagetype:"Product_image1"},
                            {id:3,imagetype:"Product_image2"},
                            {id:4,imagetype:"Product_image3"}],
            rejectreason:'',
            capture:false,
			setresolution: {height:400,width:400},
			resolution:'',
			listWarehouseData: [],
			warehouse: '',
			warehouseLoginCheck: false,
			systemLoginCheck:'',
			notcheckbtn:false,
			checkbtn:true,
			notcam:true,
			file:'',
			invalid_img_flag:false,
			vaildimg:false,
			base64String:'',
			upflag:false

	   }
	},
mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.user_type = userdetail.utype;
			// this.warehouseid  = userdetail.warehouseid;
				this.createdbyEmail = userdetail.email;
			
			
				switch (this.user_type) {
					case 'system_user':
						this.systemLoginCheck = true;
						this.warehouseLoginCheck = false;
						this.showSelectClient = true;
						this.getWarehouseList();
						this.getClientList();
						break;
		
					case 'client_user':
						this.systemLoginCheck = false;
						this.warehouseLoginCheck = false;
						this.clientid = userdetail.warehouseid;
						this.getProductData();
						break;
		
					case 'warehouse_user':
						this.systemLoginCheck = false;
						this.warehouseLoginCheck = true;
						this.warehouseid = userdetail.warehouseid;
						this.showSelectClient = true;
						this.getClientList();
						break;
		
					default:
						this.$alertify.error("Unauthorised user, Please contact your system admin");
						break
				}
				//this.setresolution=this.resolutionlist[1]
		//this.$refs.test.stop()
},
   methods: {

	handleFileUpload() {

		this.file = this.$refs.file.files[0];
		if(this.file.type=='image/jpeg' || this.file.type=='image/png' )
		{
			console.log("valid file ")
			this.invalid_img_flag=false
			this.vaildimg=true

		}
			else{
			console.log("invalid file")
			this.invalid_img_flag=true
			this.vaildimg=false
			return false
			}

	},
  
	selectresolution(){
this.setresolution=this.resolution
console.log("mm"+this.setresolution.height)
	},
	cameraSelected(){
		this.checkbtn=false
		this.notcam=false
		console.log("ramram")
		this.notcheckbtn=true
       	this.$refs.test.changeCamera(this.cameralist)
	},
	camerass(camlist){
		this.cameras=camlist
		console.log('here')
	},
	   stopcam(){
		this.checkbtn=true
		this.notcheckbtn=false
		this.$refs.test.stop()
	   },
	   startbtn(){

		 this.$refs.test.start()
		 this.$refs.test.changeCamera(this.cameralist)
		 this.checkbtn=false
		 this.notcheckbtn=true
		 this.cameras.forEach(element => {
		 console.log("saaaaa"+element.label+" "+element.deviceId)
			 
		 });
		
	   },
	   capturebtn(){
           this.capture=true
		   console.log(this.capture+"sssssss")
		   	this.$refs.test.pause()
     
	   },
	   changeswarehouse() {
		this.warehouseid = this.warehouse
	},
	   async getWarehouseList() {
		try {
			this.isLoading = true
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '')
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
				'data': {},
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
			this.listWarehouseData = result.data.data;
			this.isLoading = false
		} catch (err) {
			console.log(err);
		}
	},
	reset(){
		this.capture=false
		this.$refs.test.resume()
	},
	   		save(){
					this.capture=false
			let x= this.$refs.test.capture()
			//console.log(x)
			this.sendImageData(x)
			this.$refs.test.resume()
				
				},
			upload(){
				//console.log("here baese"+this.file)
				this.upflag=true
				this.sendImageData()
			
			},
		async sendImageData(x){
			if(this.upflag){
				var reader = new FileReader();
				reader.readAsDataURL(this.file);
			console.log("next");
			  
			
	     x=	await new Promise((resolve, reject)=>{
				reader.onload = function () {
					this.base64String = reader.result.replace("", "")
					console.log( this.base64String )
					resolve(this.base64String )
				  // x=this.base64String
				  }
			 })
			}
			this.upflag=false
			console.log("xxxxxxxx "+x)
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				this.input={
					clientid:this.client,
					warehouseid:this.warehouseid,
					imagestring:x,
					rtoid:parseInt(this.srrto),
					srid:parseInt(this.srrto),
					createdby:this.createdbyEmail,
					imagetype:this.imagetype,
					rejectreason:this.rejectreason
				}

				this.isLoading = true;
		     	axios({
						method: 'POST',
						'url': apiUrl.api_url + 'uploadImage',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						console.log(result)
					})
		},

getClientList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: this.warehouseid,
			});
			console.log(this.input)
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data && result.data.data.length > 0) {
						this.listClientData = result.data.data;
						console.log("sagar" + this.listClientData)
						// var clientListArray = [];
						// result.data.data.forEach(function(item) {
						// 	clientListArray[item.clientid] = item.clientname;
						// });
						// this.clientList = clientListArray;
					}
				}, error => {
					console.error(error);
				});
		},
clientSelected(){},

			getimages(){

				var userToken = window.localStorage.getItem('userToken');
							var myStr = userToken.replace(/"/g, '');
			this.input={
				clientid:this.client,
				warehouseid:this.warehouseid,
				srrto:this.srrto
			}
			console.log("here")
							this.isLoading = true;
						axios({
									method: 'POST',
									'url': apiUrl.api_url + 'viewImage',
									'data': this.input,
									headers: {
										'Authorization': 'Bearer ' + myStr
									}
								})
								.then(result => {
									console.log(result)
								})


			}

   }

}
 


// WEBPACK FOOTER //
// ./src/views/components/cameraapp/cameraapp.component.js